<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="众筹ID" :value="1"></el-option>
                            <el-option label="众筹名称" :value="2"></el-option>
                            <el-option label="结款方ID" :value="3"></el-option>
                            <el-option label="结款方名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制众筹状态" :value="null"></el-option>
                        <el-option label="仅看众筹中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                        <el-option label="仅看已完成的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.raiseModel" placeholder="请选择" size="small">
                        <el-option label="不限制众筹模式" :value="null"></el-option>
                        <el-option label="仅看预售的" :value="1"></el-option>
                        <el-option label="仅看普通的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.downPaymentType" placeholder="请选择" size="small">
                        <el-option label="不限制首款结款状态" :value="null"></el-option>
                        <el-option label="仅看不能申请的" :value="1"></el-option>
                        <el-option label="仅看未申请的" :value="2"></el-option>
                        <el-option label="仅看已申请的" :value="3"></el-option>
                        <el-option label="仅看已结款的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.retainageType" placeholder="请选择" size="small">
                        <el-option label="不限制尾款结款状态" :value="null"></el-option>
                        <el-option label="仅看不可申请的" :value="1"></el-option>
                        <el-option label="仅看未申请的" :value="2"></el-option>
                        <el-option label="仅看已申请的" :value="3"></el-option>
                        <el-option label="仅看已结款的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="众筹结束时间" :value="1"></el-option>
                                <el-option label="首款申请时间" :value="2"></el-option>
                                <el-option label="首款打款时间" :value="3"></el-option>
                                <el-option label="尾款申请时间" :value="4"></el-option>
                                <el-option label="尾款打款时间" :value="5"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/raise/receivables/audi/detail/excel')"  type="primary" icon="el-icon-download" size="small" @click="downloadCheck(1)" :loading="downLoading1">导出费用明细</el-button>
            <el-button v-if="$utils.have('/raise/receivables/audi/excel')"  type="primary" icon="el-icon-download" size="small" @click="downloadCheck(2)" :loading="downLoading2">导出结款信息</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="众筹ID"></el-table-column>
                <el-table-column prop="title" label="众筹名称" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="众筹状态">
                    <template slot-scope="scope">{{status.get(scope.row.status)}}</template>
                </el-table-column>
                <el-table-column prop="endTime" label="众筹结束时间" min-width="150"></el-table-column>
                <el-table-column prop="raiseModel" label="众筹模式">
                    <template slot-scope="scope">{{scope.row.raiseModel == 1 ? '预售' : '普通'}}</template>
                </el-table-column>
                <el-table-column prop="raiseMoneyFormat" label="目标筹款金额" min-width="100"></el-table-column>
                <el-table-column prop="supportNum" label="支持次数"></el-table-column>
                <el-table-column prop="raisedMoneyFormat" label="已筹款金额" min-width="100"></el-table-column>
                <el-table-column prop="downPaymentType" label="首款结款状态" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.downPaymentType == 1">不可申请</span>
                        <span v-else-if="scope.row.downPaymentType == 2">未申请</span>
                        <span v-else-if="scope.row.downPaymentType == 3">已申请</span>
                        <span v-else-if="scope.row.downPaymentType == 4">已结款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="downPaymentApplyTime" label="首款申请时间" min-width="150"></el-table-column>
                <el-table-column prop="downPaymentPlayPriceTicketFormat" label="首款打款金额" min-width="100"></el-table-column>
                <el-table-column prop="downPaymentPlayTime" label="首款打款时间" min-width="150"></el-table-column>
                <el-table-column prop="retainageType" label="尾款结款状态" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.retainageType == 1">不可申请</span>
                        <span v-else-if="scope.row.retainageType == 2">未申请</span>
                        <span v-else-if="scope.row.retainageType == 3">已申请</span>
                        <span v-else-if="scope.row.retainageType == 4">已结款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="retainageApplyTime" label="尾款申请时间" min-width="150"></el-table-column>
                <el-table-column prop="retainagePlayPriceTicketFormat" label="尾款打款金额" min-width="100"></el-table-column>
                <el-table-column prop="retainagePlayTime" label="尾款打款时间" min-width="150"></el-table-column>
                <el-table-column prop="promoterUserType" label="结款方身份" min-width="90">
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.promoterUserType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="promoter" label="结款方ID"></el-table-column>
                <el-table-column prop="promoterName" label="结款方名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/raise/receivables/audi/raiseReceivablesInfo')"
                            type="text"
                            size="small"
                            icon="el-icon-tickets"
                            @click="$refs.dataView.show(scope.row.id)"
                            >结款信息</el-button>
                        <el-button
                            v-if="$utils.have('/raise/receivables/audi/sale/incomeDetail')"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="$refs.dataDetail.show(scope.row.id)"
                            >收入明细</el-button>    
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <DataDetail ref="dataDetail"></DataDetail>
        <DataView ref="dataView" @onUpdate="getDataList"></DataView>
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
import DataDetail from './components/dataDetail';
import DataView from './components/dataView';
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: '',
    timeType:  1,
    timeFrom: null,
    timeTo: null,
    status: null,
    raiseModel: null,
    downPaymentType: null,
    retainageType: null,
}
export default {
    components:{DataDetail,DataView},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                timeType:  parseInt(this.$route.query.timeType || 1),
                timeFrom: this.$route.query.timeFrom || null,
                timeTo: this.$route.query.timeTo || null,
                status: this.$route.query.status ? parseInt(this.$route.query.status) : null,
                raiseModel: this.$route.query.raiseModel ? parseInt(this.$route.query.raiseModel) : null,
                downPaymentType: this.$route.query.downPaymentType ? parseInt(this.$route.query.downPaymentType) : null,
                retainageType: this.$route.query.retainageType ? parseInt(this.$route.query.retainageType) : null,
            },
            datetimerange:[this.$route.query.timeFrom || '' , this.$route.query.timeTo || ''],
            listLoading: true,
            downLoading1: false,
            downLoading2: false,
        }
    },
    computed:{
        status(){
            return new Map([
                [0,'发布中'],
                [1,'待审核'],
                [2,'众筹中'],
                [3,'已结束'],
                [4,'已完成'],
                [5,'未通过'],
                [6,'已取消'],
                [7,'已失败'],
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                timeFrom:this.datetimerange && this.datetimerange[0] || null,
                timeTo:this.datetimerange && this.datetimerange[1] || null
            }
            this.$request({
                url: "/raise/receivables/audi/query",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        async downloadCheck(type){
            const _loading = `downLoading${type}`
            const _fun = `download${type}`
            this[_loading] = true;
            const res = await this.$request({
                url:'/raise/receivables/audi/excel/check',
                method: 'post',
                data: this.params,
            }).catch(() => {
                this.$message({message: "请求异常", type: 'error'});
                this[_loading] = false;
            })
            const{state,msg,result} = res.data;
            if(state == 1){
                if( result && result.length > 0 ){
                    this.$confirm(`系统检测到本次导出的数据包含<span class='color-danger'>${result.length}条</span>未收入对账或对账失败的订单，请选择处理方式`,"警报", {
                        confirmButtonText: '正常导出',
                        cancelButtonText: '导出对账异常订单',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this[_fun]();
                    }).catch((action) => {
                        if(action === 'cancel'){
                            this.exportReconciliation(result,type)
                        }
                    })
                }else{
                    this[_fun]();
                }
            }else{
                return this.$message.error(msg || '下载失败');
            }
            this[_loading] = false;
        },
        //导出费用明细
        async download1(){
            let filePath;
            this.downLoading1 = true;
            const res = await this.$request({
                url:'/raise/receivables/audi/detail/excel',
                method: 'post',
                data: this.params,
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading1 = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'众筹费用明细.'+this.$utils.getFileType(filePath));
            this.downLoading1 = false;
        },
        //导出结款信息
        async download2(){
            let filePath;
            this.downLoading2 = true;
            const res = await this.$request({
                url:'/raise/receivables/audi/excel',
                method: 'post',
                data: this.params,
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading2 = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'众筹结款信息.'+this.$utils.getFileType(filePath));
            this.downLoading2 = false;
        },
        //导出异常
        async exportReconciliation(ids,type){
            const _loading = `downLoading${type}`
            let filePath;
            this[_loading] = true;
            const res = await this.$request({
                url:'/finance/exportReconciliation',
                method: 'post',
                params: {orderIds: ids.toString()},
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this[_loading] = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'众筹结款异常订单.'+this.$utils.getFileType(filePath));
            this[_loading] = false;
        }
    }
}
</script>